/** Tool logo stems under `public/assets/imgs/tools/{id}.svg` for product canvas nodes. */
export type CcProductCanvasBrandIconId =
  | "fortnox"
  | "gmail"
  | "google-calendar"
  | "hubspot"
  | "intercom"
  | "jira"
  | "linkedin"
  | "mailchimp"
  | "microsoft-teams"
  | "salesforce"
  | "shopify"
  | "slack"
  | "stripe"
  | "twilio"
  | "typeform"
  | "visma";

const PRODUCT_CANVAS_BRAND_ICON_IDS: CcProductCanvasBrandIconId[] = [
  "fortnox",
  "gmail",
  "google-calendar",
  "hubspot",
  "intercom",
  "jira",
  "linkedin",
  "mailchimp",
  "microsoft-teams",
  "salesforce",
  "shopify",
  "slack",
  "stripe",
  "twilio",
  "typeform",
  "visma",
];

const BRAND_ICON_SET = new Set<string>(PRODUCT_CANVAS_BRAND_ICON_IDS);

export function isProductCanvasBrandIconId(
  value: string,
): value is CcProductCanvasBrandIconId {
  return BRAND_ICON_SET.has(value);
}

export function getProductCanvasBrandLogoSrc(
  brand: CcProductCanvasBrandIconId,
): string {
  return `/assets/imgs/tools/${brand}.svg`;
}
